var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: { form: _vm.form, rules: _vm.rules, "label-width": "120px" },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c(
        "el-col",
        { attrs: { span: _vm.colSpan } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("BusinessPurchaseBasics.code"),
                prop: "code",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  disabled: _vm.isEdit,
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.code,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "code", $$v)
                  },
                  expression: "form.code",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.colSpan } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("BusinessPurchaseBasics.name"),
                prop: "name",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.colSpan } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("BusinessPurchaseBasics.value"),
                prop: "data",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.data,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "data", $$v)
                  },
                  expression: "form.data",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.colSpan } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("WarehouseManagement.form.Description"),
                prop: "remarks",
              },
            },
            [
              _c("BjInput", {
                attrs: { clearable: "", placeholder: _vm.$t("inputText") },
                model: {
                  value: _vm.form.remarks,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "remarks", $$v)
                  },
                  expression: "form.remarks",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.colSpan } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("BusinessPurchaseBasics.type"),
                prop: "type",
              },
            },
            [
              _c("BjSelectLov", {
                attrs: { "lov-code": "SPUR.PURCHASE_CONFIG" },
                model: {
                  value: _vm.form.type,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "type", $$v)
                  },
                  expression: "form.type",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }